export * from './ImageShrink';
//# sourceMappingURL=index.js.map